import { AppSession } from '@prisma/client'
import { Button, Flex, MenuProps } from 'antd'
import React from 'react'
import { DesignSystem } from '~/core/designSystem'
import { DropdownWithDelete } from '~/features/shared/components'
import { Icon } from '~/features/shared/icons'

type Props = {
  appSession: AppSession
  onClear: () => void
  onEdit: () => void
  onChangeStatus: (status: 'ACTIVE' | 'DISABLED') => void
}

export const Actions: React.FC<Props> = ({
  appSession,
  onClear,
  onEdit,
  onChangeStatus,
}) => {
  const designSystem = DesignSystem.use()

  const isActive = appSession?.status === 'ACTIVE'

  const isOnboarded =
    appSession?.status !== 'TO_ONBOARD' &&
    appSession?.statusOnboarding === 'DONE'

  const menuItems: MenuProps['items'] = [
    {
      key: 'clearConversation',
      label: 'Clear conversation',
      onClick: onClear,
    },
    designSystem.isMobile && {
      key: 'editAssistant',
      label: 'Edit your assistant',
      onClick: onEdit,
    },
    isOnboarded && {
      key: 'appSessionStatus',
      label: isActive ? 'Pause agent' : 'Resume agent',
      onClick: () => onChangeStatus(isActive ? 'DISABLED' : 'ACTIVE'),
    },
  ]

  return (
    <>
      <Flex>
        <DropdownWithDelete items={menuItems}>
          <Button>
            <Icon name="wrench-screwdriver" />
          </Button>
        </DropdownWithDelete>
      </Flex>
    </>
  )
}
